// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"Pricing_pageContainer__1K65J","title":"Pricing_title__25M_b","description":"Pricing_description__Kic6G"};